import React from 'react';
import { bool, shape, string } from 'prop-types';

const StatusDone = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8333 3.02169L6.17746 9.68335L3.70413 7.21002L4.52663 6.38752L6.17746 8.03835L12.0108 2.20502L12.8333 3.02169ZM11.5441 5.96169C11.62 6.29419 11.6666 6.64419 11.6666 7.00002C11.6666 9.57835 9.57829 11.6667 6.99996 11.6667C4.42163 11.6667 2.33329 9.57835 2.33329 7.00002C2.33329 4.42169 4.42163 2.33335 6.99996 2.33335C7.92163 2.33335 8.77329 2.60169 9.49663 3.06252L10.3366 2.22252C9.39163 1.55752 8.24246 1.16669 6.99996 1.16669C3.77996 1.16669 1.16663 3.78002 1.16663 7.00002C1.16663 10.22 3.77996 12.8334 6.99996 12.8334C10.22 12.8334 12.8333 10.22 12.8333 7.00002C12.8333 6.30585 12.705 5.64085 12.4833 5.02252L11.5441 5.96169Z" fill="currentColor" />
  </svg>
);

StatusDone.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default StatusDone;
